<template>
  <div class="porperty-block f-column-b" :style="computedHeightStyle">
    <block-head :title="title" :subtitle="subtitle" :icon="icon" />
    <div class="list">
      <el-table
        height="200px"
        v-if="list.length"
        class="project-table"
        :data="list"
        fit
        :default-sort="{ prop: 'endTime', order: null }"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @row-click="rowClick"
        ref="scrollTable"
        @mouseenter.native="pauseScroll"
        @mouseleave.native="resumeScroll"
      >
        <template v-if="tableType == 1">
          <el-table-column
            label="项目名称"
            min-width="380"
            header-align="center"
          >
            <template #default="{ row }">
              <div class="text-cut" :title="row.title">
                {{ row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="categoryname"
            label="类别"
            width="120"
            align="center"
          />
          <el-table-column
            prop="priceFormat"
            label="挂牌价"
            width="220"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="endDateFormat"
            label="挂牌截止时间"
            width="180"
            align="center"
          />
          <el-table-column label="项目状态" width="170" align="center">
            <template #default="scope">
              <span v-if="scope.row.ispllr == '1'" class="table-btn btn-bidding"
                >详见公告</span
              >
              <span v-if="scope.row.ispllr == '0'">
                <span
                  v-if="scope.row.statusName == '已重新挂牌'"
                  class="table-btn btn-default"
                  >已重新挂牌</span
                >
                <span
                  v-if="scope.row.statusName == '正在报名'"
                  class="table-btn btn-enroll"
                  >报名中</span
                >
                <span
                  v-if="scope.row.statusName == '正在报名|竞价中'"
                  class="table-btn btn-enroll"
                >
                  报名中
                </span>
                <span
                  v-if="scope.row.statusName == '项目终结'"
                  class="table-btn btn-default"
                  >项目终结</span
                >
                <span
                  v-if="scope.row.statusName == '项目中止'"
                  class="table-btn btn-default"
                  >项目中止</span
                >
                <span
                  v-if="scope.row.statusName == '竞价暂停'"
                  class="table-btn btn-default"
                  >竞价暂停</span
                >
                <span
                  v-if="scope.row.statusName == '竞价截止'"
                  class="table-btn btn-default"
                  >竞价截止</span
                >
                <span
                  v-if="scope.row.statusName == '未开始'"
                  class="table-btn btn-default"
                  >未开始</span
                >
                <span
                  v-if="scope.row.statusName == '报名截止'"
                  class="table-btn btn-default"
                  >报名截止</span
                >
                <span
                  v-if="scope.row.statusName == '竞价中'"
                  class="table-btn btn-bidding"
                  >竞价中</span
                >
                <span
                  v-if="scope.row.statusName == '已成交'"
                  class="table-btn none btn-default"
                  >已成交</span
                >
              </span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            label="项目名称"
            min-width="180"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <div class="text-cut" :title="row.title">
                {{ row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fbstartDate"
            label="发布时间"
            width="350"
            align="center"
          />
        </template>
      </el-table>
      <no-data
        v-else
        :no-txt="noTxt"
        :no-img="noImg"
        :text="$attrs.text"
        img-width="100px"
        img-height="100px"
      />
    </div>
  </div>
</template>

<script>
import porpertyApi from "@/api/porperty";
import NoData from "@/components/NoData.vue";
import BlockHead from "@/views/projectScroll/components/BlockHead.vue";

export default {
  name: "AssetTransaction",
  components: { BlockHead, NoData },
  props: {
    icon: {
      type: String,
      default: "asset",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "1",
    },
    noTxt: {
      type: Boolean,
      default: true,
    },
    noImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      total: 0,
      orderType: "orderType3_down",
      tableType: 1,
      scrollTimer: null,
      isScrolling: true, // 控制滚动状态
    };
  },
  // 监听属性 类似于data概念
  computed: {
    computedHeightStyle() {
      let height = this.blockHeight;
      if (typeof this.blockHeight === "string") {
        height = height.replace("px", "");
      }
      return { height: height + "px" };
    },
    blockHeight() {
      return this.type.toString() === "1" ? "272px" : "273px";
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    await this.getList();
    // 初始定位到底部
    this.$nextTick(() => {
      const divData = this.$refs.scrollTable.bodyWrapper;
      divData.scrollTop = 0;
      this.startScroll();
    });
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    }
  },
  // 方法集合
  methods: {
    startScroll() {
      const divData = this.$refs.scrollTable.bodyWrapper;
      this.scrollTimer = setInterval(() => {
        if (this.isScrolling) {
          divData.scrollTop += 1; // 关键：减少scrollTop以实现自下而上滚动
          // 判断是否滚动到顶部
          if (divData.scrollTop >= divData.scrollHeight - 175) {
            // 重置到容器底部，实现循环
            divData.scrollTop = 0;
          }
        }
      }, 30); // 滚动速度，数值越小滚动越快
    },
    pauseScroll() {
      this.isScrolling = false;
    },
    resumeScroll() {
      this.isScrolling = true;
    },
    // 获取列表
    async getList() {
      const params = {
        pageNo: 1,
        pageSize: 100,
        xmType: this.type,
        orderType: this.orderType || "default", // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
        status: "START_BM",
      };
      const res = await porpertyApi.page(params);
      if (res.code === 0) {
        const data = res.data || {};
        this.total = data.total || 0;
        this.list = data.list ?? [];
      }
    },
    headerCellStyle({ columnIndex }) {
      return "background-color: #f9f9f9;padding: 4px 0;";
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;";
      if (rowIndex === (this.total - 1 > 0 ? this.total - 1 : 0)) {
        str += "border: none;";
      }
      return str;
    },
    // 行点击
    rowClick(row) {
      if (row.noticeUrl) {
        window.open(row.noticeUrl, "_blank");
      } else {
        const route = this.$router.resolve({
          path:
            this.type.toString() === "1"
              ? "/porperty/detail/xmgg_gyzcjy"
              : "/porperty/detail/xmgg_zrzyjy",
          query: {
            id: row.infoId,
            tableType: 1,
          },
        });
        window.open(route.href, "_blank");
      }
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  width: 0 !important;
  display: none !important;
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE/Edge */
}
</style>
<style scoped lang="scss">
::v-deep .el-table th.gutter {
  border-left: none !important;
}
::v-deep .el-table colgroup col[name="gutter"] {
  border-left: none !important;
}
.block-head {
  margin: 0;
  ul > li {
    cursor: pointer;
    &.active {
      color: $--color-primary;
      font-weight: bold;
    }
    &:hover {
      color: $--color-primary;
    }
  }
}
.porperty-block {
  width: 100%;
  .list {
    flex: 1;
    min-height: 0;
    border: 1px solid #ddd;
    .project-table {
      &::before {
        height: 0;
      }
      .table-btn {
        display: inline-block;
        width: 70px;
        height: 23px;
        line-height: 23px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
</style>
